import * as pdfjs from "pdfjs-dist";
import workerSrc from "pdfjs-dist/build/pdf.worker.entry";

pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;

let rutRegex = new RegExp(/[0-9]{1,2}\.[0-9]{3}\.[0-9]{3}-\s*[0-9a-zA-Z]/g);

let factElectronicaRegex = /FACTURA\s+ELECTR\s*[OÓ]\s*NICA/i;

let factNoAfectaOExentaElectronicaRegex = new RegExp(
  /FACTURA\s+NO\s+AFECTA\s+O\s+EXENTA\s+ELECTR(O|Ó)NICA/
);
let liqFactElectronicaRegex = new RegExp(
  /LIQUIDACI(O|Ó)N\s+FACTURA\s+ELECTR(O|Ó)NICA/
);
let factCompraRegex = new RegExp(/FACTURA\s+DE\s+COMPRA/);

let numDocRegex = new RegExp(/((N(º|°)\s*)|(\s+))[0-9]{1,8}\s+/g);
const numDocRegexExt = new RegExp(/N\s*[°º]\s*[:\-]?\s*(\d{1,10})/i);

let cedibleRegex = new RegExp(/\s*CEDIBLE\s*/);

// Tipo de Documentos: (See on tbl_prg_factoringtipodocumentodetalle) -> TODO: Use slug names
// 33 Factura Electrónica Afecta
// 34 Factura no Afecta o Exenta Electrónica
// 43 Liquidación Factura Electrónica
// 46 Factura de Compra
export const esDocumentoCedible = async (file, tipoDocumento = 33) => {
  let response = {
    extRut: [],
    extTerminoDoc: false,
    extNumDoc: [],
    extCedible: false,
  };

  // Reading file
  let contents;
  try {
    contents = await new Promise((resolve) => {
      let reader = new FileReader();
      reader.onload = (e) => resolve(reader.result);
      reader.readAsArrayBuffer(file);
    });
  } catch (error) {
    return response;
  }

  // Decripting Inner Content
  const loadingTask = pdfjs.getDocument(contents);
  let pdf;

  // Es un pdf entendible
  try {
    pdf = await loadingTask.promise;
    const numPages = pdf.numPages;
    // console.log("PdfLoaded");

    if (numPages == 0 || numPages > 5) {
      return false;
    } else {
      // console.log("ReadingFile");

      for (let i = 1; i <= numPages; i++) {
        const page = await pdf
          .getPage(i)
          .catch((err) => console.log("Error: ", err));
        const textContent = await page.getTextContent();
        const pageText = textContent.items.map((i) => i.str).join(" ");

        // console.log("Page: ", i);
        // console.log("PageText: ", pageText);
        // console.log("\n");

        // Time to look
        // RUT:
        let extractedRut = [...pageText.matchAll(rutRegex)];
        for (let i = 0; i < extractedRut.length; i++) {
          response.extRut.push(extractedRut[i][0].replaceAll(" ", ""));
        }

        // Termino Tipo Documento
        let tipoDocRegex = null;
        //console.log(tipoDocumento);
        switch (
          tipoDocumento // See line 18 for more details
        ) {
          case 33:
            tipoDocRegex = factElectronicaRegex;
            break;
          case 34:
            tipoDocRegex = factNoAfectaOExentaElectronicaRegex;
            break;
          case 43:
            tipoDocRegex = liqFactElectronicaRegex;
            break;
          case 41:
            tipoDocRegex = factCompraRegex;
            break;
          default:
            break;
        }

        if (tipoDocRegex && tipoDocRegex.test(pageText)) {
          response.extTerminoDoc = true;
        }

        // Número de documento
        let extractedNumDoc = [...pageText.matchAll(numDocRegex)];
        for (let i = 0; i < extractedNumDoc.length; i++) {
          let tempNum = extractedNumDoc[i][0].match(numDocRegexExt);
          if (tempNum) response.extNumDoc.push(tempNum[0]);
        }

        // Término Cedible
        if (cedibleRegex.test(pageText)) {
          response.extCedible = true;
        }
      }
      //console.log("Processing: ", response);
      return response;
    }
  } catch (error) {
    console.log("🚀 ~ esDocumentoCedible ~ error:", error);
    return response;
  }
};
